import axios from "@/plugins/axios";

let url = "/api/console/pins";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    dashboard(data){
        return axios.get(`${url}/dashboard`, data).then(result => result.data);
    },
    statistics(type, data){
        return axios.get(`${url}/statistics/${type}`, data).then(result => result.data);
    },
    calculations(data){
        return axios.get(`${url}/calculations`, data).then(result => result.data);
    },
    issue(data){
        return axios.post(`${url}/issue`, data).then(result => result.data);
    },
    
    lock(data, config){
        return axios.patch(`${url}/lock`, data, config).then(result => result.data);
    },
    unlock(data, config){
        return axios.patch(`${url}/unlock`, data, config).then(result => result.data);
    },
    cancel(data, config){
        return axios.patch(`${url}/cancel`, data, config).then(result => result.data);
    },
    platform(data, config){
        return axios.patch(`${url}/platform`, data, config).then(result => result.data);
    },
    update(data){
        return axios.patch(`${url}/update`, data).then(result => result.data);
    },

    expire3: {
        gets(data){
            return axios.get(`${url}/expire3`, data).then(result => result.data);
        }
    }
}
